import styled, { css } from 'styled-components'

export const StyledEvents = styled.div``

export const ModalLoadingWrapper = styled.div<{ isNotification?: boolean; withDesc?: boolean }>`
  .xl {
    display: none;
  }

  p {
    margin-bottom: 0;
  }

  .img-btn-grp {
    display: none;
  }

  ${({ isNotification, withDesc }) =>
    isNotification &&
    css`
      h1 {
        margin-bottom: 0 !important;
      }

      div {
        div:nth-child(${withDesc ? 6 : 5}) {
          display: none;
        }
      }
    `}
`
